<template>
    <h4 class="title-line-after">{{ title }}</h4>
</template>

<script>
  export default {
    name: 'SectionTitleAfter',
    props: {
      title: {
        type: String,
        required: true
      }
    }
  }
</script>



// WEBPACK FOOTER //
// resources/js/app/components/SectionTitleAfter.vue